import { useCallback, useEffect, useState } from "react";
import { KEY } from "@/react/components/table/useTableMutations";

export const useEditableCell = ({
  getValue,
  column,
  row,
  table,
  externalOnChange,
}) => {
  const initialValue = getValue();

  const { updateRows, skipAutoResetPageIndex, schema } = table.options.meta;

  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue, setValue]);

  const onChange = useCallback(
    (newValue) => {
      setValue(newValue);
      externalOnChange && externalOnChange(newValue);
    },
    [setValue, schema, externalOnChange]
  );

  const onBlur = useCallback(() => {
    skipAutoResetPageIndex();
    if (!row) {
      return;
    }
    updateRows([row.original[KEY]], new Map([[column.id, value]]), schema);
  }, [row, column, value, updateRows, skipAutoResetPageIndex]);

  return {
    initialValue,
    value,
    onChange,
    onBlur,
  };
};

export default useEditableCell;
